module.exports = __webpack_public_path__ + "img/PHONE_CALL.7bd565c4.svg";